import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import UploadButton from "../Uploader/UploadButton";
import { all as translations } from "../../modules/translations/translations";
import InputModal from "../Helpers/Modal/InputModal";

export default function General(props) {
  const [team, setTeam] = useState(props.team);
  const [saving, setSaving] = useState(false);
  const [openDonors, setOpenDonors] = useState(false)
  const [openBeneficiaries, setOpenBeneficiaries] = useState(false)
  const [donorContent, setDonorContent] = useState(`Invite All ${team.donor_title}s`)
  const [beneficiaryContent, setBeneficiaryContent] = useState(`Invite All ${team.beneficiary_title}s`)
  const [beneficiaryFlag, setBeneficiaryFlag] = useState(false)

  useEffect(() => {
    if (team.beneficiary_title == 'Beneficiary') {
      setBeneficiaryContent('Invite All Beneficiaries')
    }

    team.feature_flags.map(flag => {
      if (flag == 'beneficiary_logins') {
        setBeneficiaryFlag(true)
        return
      }
    })
  }, [])

  const users = props.users

  const setLogoImage = (blob) => {
    setTeam(team => {
      return {
        ...team,
        logo: blob.signed_id,
        logo_url: blob.cdn_url
      }
    });
  }
  const handleSubmit = () => {
    setSaving(true)
    HTTP.patch(`/settings`, {
      team: team,
      domain_settings: null
    }).then(response => {
      Alert.show("notice", "Settings saved!");
      setTeam(response.data);

      setSaving(false);
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })
  }

  const handleInvite = (message, userType) => {
    setSaving(true)

    let filteredUsers = users.filter(user => user.user_type == userType && !user.invitation_accepted_at && user.email)

    let count = 0
    filteredUsers.map(user => {
      let data = {
        id: user.id,
        custom_message: message
      }

      try {
        sendInvites(data)
      } catch {
        return
      }

      count = count + 1
    })

    if (count == filteredUsers.length && userType == 'donor') {
      setOpenDonors(false)
      setSaving(false)
      setDonorContent('Invites Sent')
      Alert.show('notice', `Invitations where sent out to ${count} ${team.donor_title}(s)`)
    } else if (count == filteredUsers.length && userType == 'beneficiary') {
      setOpenBeneficiaries(false)
      setSaving(false)
      setBeneficiaryContent('Invites Sent')
      Alert.show('notice', `Invitations where sent out to ${count} ${team.beneficiary_title}(s)`)
    }
  }

  const sendInvites = (data) => {
    return HTTP.post('/invites', data)
  }

  const handleDonors = () => {
    let donors = users.filter(user => user.user_type == 'donor')

    if (donors.length < 1) {
      Alert.show('notice', `You do not have any ${team.donor_title.toLowerCase()}`)
      return
    }

    let withEmail = donors.filter(donor => donor.email.length > 4)
    if (withEmail.length < 1) {
      Alert.show('notice', `None of your ${team.donor_title.toLowerCase()} have an email`)
      return
    }

    let notAccepted = withEmail.filter(donor => !donor.invitation_accepted_at)
    if (notAccepted < 1) {
      Alert.show('notice', `All ${team.donor_title.toLowerCase()}(s) with email have accepted their invitations`)
      return
    }

    setOpenDonors(true)
  }

  const handleBeneficiaries = () => {
    let beneficiaries = users.filter(user => user.user_type == 'beneficiary')

    if (beneficiaries.length < 1) {
      Alert.show('notice', `You do not have any ${team.beneficiary_title.toLowerCase()}`)
      return
    }

    let withEmail = beneficiaries.filter(beneficiary => beneficiary.email.length > 4)
    if (withEmail.length < 1) {
      Alert.show('notice', `None of your ${team.beneficiary_title.toLowerCase()} have an email`)
      return
    }

    let notAccepted = withEmail.filter(beneficiary => !beneficiary.invitation_accepted_at)
    if (notAccepted < 1) {
      Alert.show('notice', `All ${team.beneficiary_title.toLowerCase()}(s) with email have accepted their invitations`)
      return
    }

    setOpenBeneficiaries(true)
  }


  return (
    <div className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">
            General Settings
          </h4>
        </div>
        <div>
          <button onClick={handleSubmit} name="button" className="btn btn-primary">
            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
            Save
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="organization_name">Organization Name</label>
              <input className="form-control" placeholder="Our Organization" type="text" name="organization_name" id="organization_name"
                value={team.name}
                onChange={e => {
                  const val = e.target.value;
                  setTeam(team => {
                    return { ...team, name: val }
                  });
                }}
              />
            </div>
            <div className="ml-3 mb-4">
              <small>Organization name will be used in a public page's subdomain.</small>
            </div>
            <div className="form-group">
              <label>Logo</label>
              <div className="border rounded bg-grey1 p-2">
                <div className="d-flex">
                  <img className="img-fluid mx-auto my-2"
                    style={{maxWidth: '200px'}}
                    src={team.logo_url} />
                </div>
                <div className='mt-2'>
                  <UploadButton handleChange={setLogoImage} />
                </div>
              </div>
            </div>
            </div>
          <div className="col-md-6">
            <div className="my-2">
              <strong>Organization settings</strong>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="using_approval"
                checked={team.using_approvals}
                onChange={checked => {
                  setTeam(team => ({...team, using_approvals: checked }))
                }}
              />
              <label htmlFor="using_approvals">Require approval on posts</label>
            </div>
            {team.stripe_uid &&
              <>
                <div className="my-2">
                  <strong>Payment settings</strong>
                </div>
                <div className="form-group">
                  <ToggleSwitch
                    small
                    id="sub_cancelation"
                    checked={team.permit_sub_cancelation}
                    onChange={checked => {
                      setTeam(team => ({...team, permit_sub_cancelation: checked }))
                    }}
                  />
                  <label htmlFor="sub_cancelation">Permit users to cancel subscriptions</label>
                </div>
              </>
            }
            {props.page_flag &&
              <>
                <div className="my-2">
                  <strong>Pages settings</strong>
                </div>
                <div className="form-group">
                  <ToggleSwitch
                    small
                    id="show_page"
                    checked={team.show_public_pages}
                    onChange={checked => {
                      setTeam(team => ({...team, show_public_pages: checked }))
                    }}
                  />
                  <label htmlFor="show_page">Show public pages to { props.donor_plural.toLowerCase() }</label>
                </div>
              </>
            }
            <div className="my-2">
              <strong>Post Settings</strong>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="post_thread"
                checked={team.admin_post_thread_public}
                onChange={checked => {
                  setTeam(team => ({...team, admin_post_thread_public: checked }))
                }}
              />
              <label htmlFor="post_thread">
                Public comments for admin posts
              </label>
            </div>
            <div className="my-2">
              <strong>Platform Control</strong>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="show_sponsor_project"
                checked={team.show_sponsor_project}
                onChange={checked => {
                  setTeam(team => ({...team, show_sponsor_project: checked }))
                }}
              />
              <label htmlFor="show_sponsor_project">
                Show {props.project_plural.toLowerCase()} to {props.donor_plural.toLowerCase()}
              </label>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="show_sponsor_communities"
                checked={team.show_sponsor_communities}
                onChange={checked => {
                  setTeam(team => ({...team, show_sponsor_communities: checked }))
                }}
              />
              <label htmlFor="show_sponsor_communities">
                Show communities to {props.donor_plural.toLowerCase()}
              </label>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="show_sponsor_reports"
                checked={team.show_sponsor_reports}
                onChange={checked => {
                  setTeam(team => ({...team, show_sponsor_reports: checked }))
                }}
              />
              <label htmlFor="show_sponsor_reports">
                Show reports to {props.donor_plural.toLowerCase()}
              </label>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="show_sponsor_send_message"
                checked={team.show_sponsor_send_message}
                onChange={checked => {
                  setTeam(team => ({...team, show_sponsor_send_message: checked }))
                }}
              />
              <label htmlFor="show_sponsor_send_message">
                Show send message button to {props.donor_plural.toLowerCase()}
              </label>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="show_beneficiary_send_message"
                checked={team.show_beneficiary_send_message}
                onChange={checked => {
                  setTeam(team => ({...team, show_beneficiary_send_message: checked }))
                }}
              />
              <label htmlFor="show_beneficiary_send_message">
                Show send message button to {props.beneficiary_plural.toLowerCase()}
              </label>
            </div>
            <div className="my-2">
              <strong>Notification settings</strong>
            </div>
            <div className="form-group">
              <ToggleSwitch
                small
                id="audience_notifications_enabled"
                checked={team.audience_notifications_enabled}
                onChange={checked => {
                  setTeam(team => ({...team, audience_notifications_enabled: checked }))
                }}
              />
              <label htmlFor="audience_notifications_enabled">Enable audience email notifications</label>
              {team.audience_notifications_enabled && (
                <div className="additional-settings">
                  <ToggleSwitch
                    small
                    id="audience_notifications_preview"
                    checked={team.audience_notifications_preview}
                    onChange={checked => {
                      setTeam(team => ({...team, audience_notifications_preview: checked }))
                    }}
                  />
                  <label htmlFor="audience_notifications_preview">Enable content previews (in emails)</label>
                </div>
              )}
              <div className="description mb-4">
                <small>Email sent to audience when post created.</small><br/>
                <small>If approvals on, post must be approved to trigger.</small><br/>
                <small>{translations.donors} can individually opt-out.</small>
              </div>
              <ToggleSwitch
                small
                id="admin_donor_notifications_enabled"
                checked={team.admin_donor_notifications_enabled}
                onChange={checked => {
                  setTeam(team => ({...team, admin_donor_notifications_enabled: checked }))
                }}
              />
              <label htmlFor="admin_donor_notifications_enabled">Enable donor post admin notifications</label>
              <div className="description mb-4">
                <small>Email sent to admin when post created by donor.</small><br/>
                <small>If approvals on, admin will receive notice of approval required.</small><br/>
              </div>
              <ToggleSwitch
                small
                id="admin_beneficiary_notifications_enabled"
                checked={team.admin_beneficiary_notifications_enabled}
                onChange={checked => {
                  setTeam(team => ({...team, admin_beneficiary_notifications_enabled: checked }))
                }}
              />
              <label htmlFor="admin_beneficiary_notifications_enabled">Enable beneficiary post admin notifications</label>
              <div className="description mb-4">
                <small>Email sent to admin when post created by beneficiary.</small><br/>
                <small>If approvals on, admin will receive notice of approval required.</small><br/>
              </div>
              <ToggleSwitch
                small
                id="admin_field_notification"
                checked={team.send_admin_field_notifications}
                onChange={checked => {
                  setTeam(team => ({...team, send_admin_field_notifications: checked }))
                }}
              />
              <label htmlFor="admin_field_notification">Enable field change notification for admin</label>
              <div className="description mb-4">
                <small>Email sent to admin when a field that has notifications enabled is changed for any user or project.</small><br/>
              </div>
              <div>
                <label htmlFor="user-invitaions">Mass Invite Functionality</label>
              <div id="user-invitations">
                <button className="btn btn-primary btn-sm mr-2" onClick={handleDonors}>
                  {donorContent}
                </button>

                {beneficiaryFlag &&
                <button className="btn btn-secondary btn-sm" onClick={handleBeneficiaries}>
                  {beneficiaryContent}
                </button>
                }
                <br/>
                <div className="mt-2">
                  <small>Send invite to all donors and beneficiaries that have not accepted invite.</small><br/>
                  <small><b>Users without email will be skipped</b></small>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openDonors &&
        <InputModal saving={saving} handleInvite={(message, userType) => handleInvite(message, userType)} handleClose={() => setOpenDonors(false)} userType="donor"/>
      }

      {openBeneficiaries &&
        <InputModal saving={saving} handleInvite={(message, userType) => handleInvite(message, userType)} handleClose={() => setOpenBeneficiaries(false)} userType="beneficiary" />
      }
    </div>
  );
}
General.propTypes = {
  team: PropTypes.object
};
